import React, { useState } from "react";
import { Row, Col, Button, Divider } from "antd";
import textStyles from "../../Shared/Styles/TextStyles.module.scss";
import styles from "./ShoppingCart.module.scss";
import { CartGroceryItem } from "../../../types/GroceryTypes";
import dividerStyles from "../../Shared/Styles/DividerStyles.module.scss";
import GroceryAddItems from "../GroceryAddItems/GroceryAddItems";
import { useGroceryCtx } from "../../../context/GroceryContext";

type Props = {
  shoppingCartGroceryItems: CartGroceryItem;
};

function GroceryCartItemView({ shoppingCartGroceryItems }: Props) {
  const { cachedGroceryCartItemsCtx } = useGroceryCtx();
  const [cachedGroceryCartItems] = cachedGroceryCartItemsCtx;

  const groceryItemCount: number =
    cachedGroceryCartItems?.find(
      (e: { groceryId: number }): any =>
        e.groceryId === shoppingCartGroceryItems.groceryId
    )?.quantity ?? 0;
  const [currentCount, setCurrentCount] = useState<number>(groceryItemCount);
  const [isClicked, setIsClicked] = useState<boolean>(false);

  return (
    <>
      <Row>
        <Col span={6}>
          {shoppingCartGroceryItems.imageUrl ? (
            <img
              className={styles.shoppingCartItemImg}
              src={shoppingCartGroceryItems.imageUrl}
              alt="grocery_item"
            />
          ) : (
            <Col
              className={`${styles.defaultImage} ${textStyles.normalText20}`}
            >
              {shoppingCartGroceryItems.productName[0].toUpperCase()}
            </Col>
          )}
        </Col>
        <Col span={1} />
        <Col span={17}>
          <Row className={`${textStyles.boldText14} ${styles.marginDown20}`}>
            {shoppingCartGroceryItems.productName}{" "}
            {shoppingCartGroceryItems.weight}{" "}
            {shoppingCartGroceryItems.weightType}
          </Row>
          <Row className={styles.cartItemDetails}>
            <Col
              sm={isClicked ? 1 : 8}
              xs={isClicked ? 1 : 8}
              className={`${styles.cartCostEachItem} ${isClicked &&
                styles.costDisplayNoWrap}`}
            >
              {shoppingCartGroceryItems.cost.toFixed(2)}{" "}
              {shoppingCartGroceryItems.costType}
            </Col>
            <Col sm={isClicked ? 17 : 8} xs={isClicked ? 19 : 8}>
              <Row
                className={
                  isClicked
                    ? styles.cartfloatingCounterBtn
                    : styles.cartItemQuantity
                }
              >
                {isClicked ? (
                  <GroceryAddItems
                    groceryItem={shoppingCartGroceryItems}
                    groceryCartCount={currentCount}
                    currentCount={currentCount}
                    setCurrentCount={setCurrentCount}
                  />
                ) : (
                  <Button
                    className={textStyles.boldText16}
                    onClick={() => setIsClicked(!isClicked)}
                  >
                    <div>{shoppingCartGroceryItems.quantity}</div>
                  </Button>
                )}
              </Row>
            </Col>
            <Col
              sm={isClicked ? 6 : 8}
              xs={isClicked ? 4 : 8}
              className={`${textStyles.boldText14} ${
                styles.alignTextRight
              } ${isClicked && styles.costDisplayHidden}`}
            >
              ${shoppingCartGroceryItems?.totalCost?.toFixed(2)}
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className={dividerStyles.solidFadedDivider} />
    </>
  );
}

export default GroceryCartItemView;
